import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-neutral-800 text-neutral-300 mt-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* About Section */}
          <div>
            <h3 className="text-white text-lg font-semibold mb-4">About</h3>
            <p className="text-sm leading-relaxed">
              Artinent.com delivers the latest news and insights from Australia and around the world. 
              Stay informed with our comprehensive coverage of current events.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/contact" className="hover:text-primary-400 transition-colors">
                  Contact
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="hover:text-primary-400 transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" className="hover:text-primary-400 transition-colors">
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link to="/impressum" className="hover:text-primary-400 transition-colors">
                  Impressum
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Information */}
          <div>
            <h3 className="text-white text-lg font-semibold mb-4">Contact</h3>
            <div className="text-sm space-y-2">
              <p>
                <span className="font-medium">News Pty Limited</span><br />
                ACN: 007 871 187<br />
                ABN: 47 007 871 187
              </p>
              <p>
                <span className="font-medium">Address:</span><br />
                2 Holt Street<br />
                Surry Hills NSW 2010<br />
                Australia
              </p>
              <p>
                <span className="font-medium">Phone:</span><br />
                +61 2 9288 3000
              </p>
              <p>
                <span className="font-medium">Email:</span><br />
                info@Artinent.com
              </p>
            </div>
          </div>
        </div>

        <div className="border-t border-neutral-700 mt-8 pt-8 text-center text-sm">
          <p className="mb-2">&copy; {new Date().getFullYear()} News Pty Limited. All rights reserved.</p>
          <p className="text-neutral-400">ACN: 007 871 187 | ABN: 47 007 871 187</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
